import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/peacemaker/visual_peacemaker.png")